import React, { FC, memo, useEffect, useRef, useState } from "react";
import { ChatHeaderTitle } from "./components/chat-header-title";
import { useTheme } from "styled-components";
import { ChatHeaderIcon } from "./components/chat-header-icon";
import { ChatHeaderContainer } from "./components/chat-header-container";
import { AIStarIcon } from "../../components/icons/ai-star-icon";
import { HeaderCloseChatIcon } from "../../components/icons/header-close-chat-icon";
import { useAppDispatch } from "../../../common/store";
import { setIsOpen } from "../../../common/store/app-state/app-state-slice";
import { sendMessageLogSubmission } from "../../../common/store/chat/thunks/send-message-log";
import getMessageByVurablizeEvent from "../../utils/get-message-by-vurablize-event";
import VurbalizeEvents from "../../../common/types/dto/chat/vurbalize-events";

interface ChatFrameProps {
}

const ChatHeader: FC<ChatFrameProps> = ({
}) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const closeChat = () => {
    dispatch(setIsOpen(false));
    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.WIDGET_CHAT_HEADER_CLOSE),
        event_name: VurbalizeEvents.WIDGET_CHAT_HEADER_CLOSE,
        event_data: {
          timestamp: Date.now(),
        },
      }
    }))
  }
  const title = theme?.themeConfig?.chatHeader?.title?.text;
  const inversion = theme?.themeConfig?.chatHeader?.inversion;
  return (
    <ChatHeaderContainer className="voa_chat_header">
      <ChatHeaderTitle className="voa_chat_header_title">
        {!inversion && title}
            {theme?.themeConfig?.chatHeader?.icon?.src && (
        <div className="voa_chat_header_title_icon">
          <ChatHeaderIcon className="voa_chat_header_title_icon">
              <img
              src={theme?.themeConfig?.chatHeader?.icon?.src}
              alt="Chat Icon"
              width={20}
              height={20}
              style={{ width: '20px', height: '20px'}}
            />
          </ChatHeaderIcon>
        </div>
            )}
        {inversion && title}
      </ChatHeaderTitle>

      {/* <div
        className="voa_chat_header_close_icon"
        onClick={closeChat}
      >
        <HeaderCloseChatIcon />
      </div> */}
    </ChatHeaderContainer>
  )
};

export default ChatHeader;